// src/pages/ContentEditor/components/DiscardChangesDialog.js
import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogContentText, 
  DialogActions, 
  Button 
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DiscardChangesDialog = ({ open, onCancel, onConfirm }) => {
  const theme = useTheme();
  
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="discard-dialog-title"
      aria-describedby="discard-dialog-description"
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.paper,
          borderRadius: 1
        }
      }}
    >
      <DialogTitle id="discard-dialog-title" sx={{ color: theme.palette.text.primary }}>
        Discard Unsaved Changes
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="discard-dialog-description" sx={{ color: theme.palette.text.secondary }}>
          You have unsaved changes. Are you sure you want to leave without saving? Your changes will be lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} sx={{ color: theme.palette.text.primary }}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          Discard Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DiscardChangesDialog;
